import { useEffect, useRef, useState } from "react";

export const useCountUp = (value, ms = 700) => {
  const [v, setV] = useState(value);
  const from = useRef(value);
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      from.current = value;
      setV(value);
      return;
    }
    const start = performance.now(), a = from.current;
    let raf;
    const tick = (t) => {
      const k = Math.min((t - start) / ms, 1);
      const cur = a + (value - a) * (1 - Math.pow(1 - k, 3));
      from.current = cur;
      setV(cur);
      if (k < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [value, ms]);
  return v;
};
